/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from 'react';

import styles from './InputRadio.module.css';

/**
 * `InputRadio` radio input component.
 *
 * @typedef {Object} Props The properties for the `TextField` component.
 * @property {string} id The id of the text field, used for identification.
 * @property {string} name The name of the text field, used for identification.
 * @property {string} label The label associated with the text field.
 * @property {string} [value] The selected value.
 * @property {boolean} [defaultChecked] If `true`, the input will be checked by default on init.
 * @property {import("react").MouseEventHandler<HTMLInputElement>} [onClick=()=>{}] onClick event.
 * @property {import('react').ComponentPropsWithoutRef<"input">} [props.props]
 */

/**
 * @type React.ForwardRefExoticComponent<Props>
 */
export const InputRadio = forwardRef(({
  name,
  id,
  label,
  value,
  defaultChecked,
  onClick,
  ...props
}, ref) => (
  <label htmlFor={id} className={styles.label}>
    <input
      ref={ref}
      type="radio"
      id={id}
      name={name}
      value={value}
      className={styles.input}
      onClick={onClick}
      {...props}
      defaultChecked={defaultChecked}
    />
    <span className={styles['label-button']}>{label}</span>
  </label>
));

export default InputRadio;
